export type PresetPalette = {
  name: string;
  description: string;
  is_default: boolean;
  is_active: boolean;
  colors: Record<string, string>;
};

// Material-like balanced HSL sets. Tuned for contrast and harmony.
export const MATERIAL_PRESETS: PresetPalette[] = [
  {
    name: "Material Blue",
    description: "Azuis clássicos com bom contraste e destaque neutro.",
    is_default: true,
    is_active: false,
    colors: {
      primary: "207 100% 35%",
      secondary: "197 100% 45%",
      accent: "200 100% 40%",
      sidebar: "215 100% 18%",
      success: "142 71% 45%",
      warning: "43 96% 56%",
      error: "0 84% 60%",
    },
  },
  {
    name: "Material Green",
    description: "Verdes modernos com foco em legibilidade e frescor.",
    is_default: false,
    is_active: false,
    colors: {
      primary: "142 72% 32%", // emerald-700 like
      secondary: "142 65% 40%",
      accent: "142 70% 45%",
      sidebar: "150 20% 14%",
      success: "142 71% 45%",
      warning: "43 96% 56%",
      error: "0 84% 60%",
    },
  },
  {
    name: "Material Orange",
    description: "Laranjas energéticos com bom contraste para CTAs.",
    is_default: false,
    is_active: false,
    colors: {
      primary: "28 90% 48%", // orange-600 like
      secondary: "28 92% 55%",
      accent: "24 90% 50%",
      sidebar: "24 25% 14%",
      success: "142 71% 45%",
      warning: "43 96% 56%",
      error: "0 84% 60%",
    },
  },
  {
    name: "Material Red",
    description: "Vermelhos fortes com contraste consistente para alertas.",
    is_default: false,
    is_active: false,
    colors: {
      primary: "0 75% 45%", // red-600 like
      secondary: "0 72% 52%",
      accent: "355 80% 46%",
      sidebar: "0 20% 14%",
      success: "142 71% 45%",
      warning: "43 96% 56%",
      error: "0 84% 60%",
    },
  },
  {
    name: "Material Purple",
    description: "Roxos elegantes com destaque sofisticado.",
    is_default: false,
    is_active: false,
    colors: {
      primary: "268 70% 45%", // violet-600 like
      secondary: "268 72% 55%",
      accent: "268 65% 50%",
      sidebar: "262 25% 14%",
      success: "142 71% 45%",
      warning: "43 96% 56%",
      error: "0 84% 60%",
    },
  },
];

export function getPresetByName(name: string): PresetPalette | undefined {
  return MATERIAL_PRESETS.find((p) => p.name === name);
}


